import React, {
  useState,
} from "react";

import {
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

import i18next from "i18next";

import "./ReisorProRoleGate.css";

const COPY = {
  ru: {
    tagline:
      "ГРУЗЫ • МАШИНЫ • ЛЮДИ • ВОЗМОЖНОСТИ",

    cargo:
      "Грузовладелец",

    cargoText:
      "Размещайте грузы и находите перевозчиков",

    expeditor:
      "Экспедитор",

    expeditorText:
      "Работайте с грузами в одном месте",

    driver:
      "Водитель",

    driverText:
      "Грузы, рейсы и работа водителя",

    back:
      "Назад",

    nextTitle:
      "REISOR PRO",

    nextCargo:
      "Грузовладелец",

    nextExpeditor:
      "Экспедитор",

    nextText:
      "Следующий шаг — простая регистрация по номеру телефона и паролю.",
  },

  uz: {
    tagline:
      "ЮКЛАР • МАШИНАЛАР • ОДАМЛАР • ИМКОНИЯТЛАР",

    cargo:
      "Юк эгаси",

    cargoText:
      "Юкларни жойланг ва ташувчиларни топинг",

    expeditor:
      "Экспедитор",

    expeditorText:
      "Юклар билан бир жойда ишланг",

    driver:
      "Ҳайдовчи",

    driverText:
      "Юклар, рейслар ва ҳайдовчи иши",

    back:
      "Орқага",

    nextTitle:
      "REISOR PRO",

    nextCargo:
      "Юк эгаси",

    nextExpeditor:
      "Экспедитор",

    nextText:
      "Кейинги қадам — телефон рақами ва пароль билан оддий рўйхатдан ўтиш.",
  },

  tr: {
    tagline:
      "YÜKLER • ARAÇLAR • İNSANLAR • FIRSATLAR",

    cargo:
      "Yük sahibi",

    cargoText:
      "Yük ilanı verin ve taşıyıcı bulun",

    expeditor:
      "Nakliye organizatörü",

    expeditorText:
      "Yüklerle tek yerde çalışın",

    driver:
      "Sürücü",

    driverText:
      "Yükler, seferler ve sürücü işleri",

    back:
      "Geri",

    nextTitle:
      "REISOR PRO",

    nextCargo:
      "Yük sahibi",

    nextExpeditor:
      "Nakliye organizatörü",

    nextText:
      "Sonraki adım: telefon numarası ve şifreyle hızlı kayıt.",
  },
};

const LANGUAGES = [
  {
    code: "ru",
    label: "Русский",
    short: "RU",
  },
  {
    code: "uz",
    label: "Ўзбекча",
    short: "UZ",
  },
  {
    code: "tr",
    label: "Türkçe",
    short: "TR",
  },
];

const ROLES = {
  cargo: {
    role: "CARGO",
    image:
      "/reisor/entrance/cargo.webp",
    accent:
      "orange",
  },

  expeditor: {
    role: "EXPEDITOR",
    image:
      "/reisor/entrance/expeditor.webp",
    accent:
      "blue",
  },

  driver: {
    role: "DRIVER",
    image:
      "/reisor/entrance/driver.webp",
    accent:
      "green",
  },
};

function languageCode() {
  const raw =
    String(
      i18next.resolvedLanguage ||
        i18next.language ||
        "ru"
    )
      .toLowerCase()
      .slice(0, 2);

  return COPY[raw]
    ? raw
    : "ru";
}

function LanguageSwitch({
  lang,
  onChange,
}) {
  return (
    <div
      className="rp-entrance-languages"
      role="group"
      aria-label="Language"
    >
      {LANGUAGES.map(
        (item) => (
          <button
            key={item.code}
            type="button"
            className={
              lang === item.code
                ? "is-active"
                : ""
            }
            aria-pressed={
              lang === item.code
            }
            onClick={() =>
              onChange(
                item.code
              )
            }
          >
            <strong>
              {item.short}
            </strong>

            <span>
              {item.label}
            </span>
          </button>
        )
      )}
    </div>
  );
}

function RoleCard({
  title,
  text,
  config,
  onClick,
}) {
  return (
    <button
      type="button"
      className={
        `rp-entrance-role rp-entrance-role--${config.accent}`
      }
      onClick={onClick}
    >
      <span className="rp-entrance-role__visual">
        <img
          src={config.image}
          alt=""
          aria-hidden="true"
          loading="eager"
          decoding="async"
        />
      </span>

      <span className="rp-entrance-role__copy">
        <strong>
          {title}
        </strong>

        <span>
          {text}
        </span>
      </span>

      <span
        className="rp-entrance-role__arrow"
        aria-hidden="true"
      >
        <ChevronRight
          size={25}
          strokeWidth={2.5}
        />
      </span>
    </button>
  );
}

export default function ReisorProRoleGate({
  onSelect,
}) {
  const [lang, setLang] =
    useState(
      () =>
        languageCode()
    );

  const t =
    COPY[lang] ||
    COPY.ru;

  function selectLanguage(
    next
  ) {
    if (!COPY[next]) {
      return;
    }

    setLang(next);

    try {
      localStorage.setItem(
        "gptcargo_lang",
        next
      );
    } catch {}

    Promise.resolve(
      i18next.changeLanguage(
        next
      )
    ).catch(() => {});
  }

  return (
    <main className="rp-gate rp-gate--entrance">
      <div className="rp-entrance-shell">
        <LanguageSwitch
          lang={lang}
          onChange={
            selectLanguage
          }
        />

        <header className="rp-entrance-brand">
          <div className="rp-entrance-wordmark">
            REISOR
          </div>

          <div className="rp-entrance-tagline">
            {t.tagline}
          </div>
        </header>

        <div className="rp-entrance-hero">
          <img
            src="/reisor/entrance/hero.webp"
            alt=""
            aria-hidden="true"
            loading="eager"
            decoding="async"
          />
        </div>

        <section
          className="rp-entrance-roles"
          aria-label="REISOR"
        >
          <RoleCard
            title={t.cargo}
            text={t.cargoText}
            config={ROLES.cargo}
            onClick={() =>
              onSelect?.(
                "CARGO"
              )
            }
          />

          <RoleCard
            title={
              t.expeditor
            }
            text={
              t.expeditorText
            }
            config={
              ROLES.expeditor
            }
            onClick={() =>
              onSelect?.(
                "EXPEDITOR"
              )
            }
          />

          <RoleCard
            title={t.driver}
            text={t.driverText}
            config={ROLES.driver}
            onClick={() =>
              onSelect?.(
                "DRIVER"
              )
            }
          />
        </section>
      </div>
    </main>
  );
}

export function ReisorProMarketRoleNext({
  role,
  onBack,
}) {
  const t =
    COPY[
      languageCode()
    ] || COPY.ru;

  const roleTitle =
    role === "EXPEDITOR"
      ? t.nextExpeditor
      : t.nextCargo;

  return (
    <main className="rp-gate rp-gate--next">
      <section className="rp-next">
        <button
          type="button"
          className="rp-back"
          onClick={onBack}
        >
          <ChevronLeft
            size={19}
            aria-hidden="true"
          />

          {t.back}
        </button>

        <div className="rp-next-brand">
          REISOR
        </div>

        <div className="rp-next__card">
          <span className="rp-next__eyebrow">
            {t.nextTitle}
          </span>

          <h1>
            {roleTitle}
          </h1>

          <p>
            {t.nextText}
          </p>
        </div>
      </section>
    </main>
  );
}
